import { useEffect, useState } from "react";
import styles from "../postDetailComponent/postDetailComponent.module.scss";
import { useRouter } from "next/router";
import { convertSlugs } from "../../util/functionGlobal";

interface TopProps {
  refProps: any;
}

const ScrollMenu = ({ refProps }: TopProps) => {
  const [headings, setHeadings] = useState([]);
  const router = useRouter();

  const [activeHeading, setActiveHeading] = useState("");

  //scroll focus content h2 left
  useEffect(() => {
    const handleScroll = () => {
      let content = document.querySelector("#_content");
      const h2Elements = Array.from(content.querySelectorAll("h2"));
      const scrollPosition = window.scrollY;
      let activeIndex = -1;
      for (let i = 0; i < h2Elements.length; i++) {
        const element = h2Elements[i];
        const elementOffsetTop = element.offsetTop;

        if (scrollPosition >= elementOffsetTop) {
          activeIndex = i;
        }
      }

      if (activeIndex !== -1) {
        const activeHeadingText = h2Elements[activeIndex].textContent;
        setActiveHeading(activeHeadingText);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const updateHeadings = () => {
      let content = document.querySelector("#_content");
      if (content) {
        const h2Elements = Array.from(content.querySelectorAll("h2"));
        const headingTexts = h2Elements.map((element) => element.textContent);
        setHeadings(headingTexts);
      }
    };

    updateHeadings();

    const handleRouteChange = (url: string, { shallow }) => {
      updateHeadings();
      const hash = url.split("#")[1];
      if (hash) {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }

      if (shallow) {
        router.events.off("routeChangeComplete", handleRouteChange);
      }
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);

  const handleClick = (hash: string) => {
    const element = document.getElementById(hash);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {headings.length > 0 && (
        <div className={styles["scroll-menu-focus"]} ref={refProps}>
          <div className={styles["h3"]}>
            <span style={{cursor : "default"}}>Tổng quan bài viết</span>
          </div>
          <ul className={styles["ul-focus"]}>
            {headings.map((heading, index) => {
              const hash = convertSlugs(heading);
              return (
                <li
                  key={index}
                  className={styles[heading === activeHeading ? "active" : ""]}
                  onClick={() => handleClick(hash)}
                  data-scroll-to={hash}
                >
                  {heading}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export default ScrollMenu;
